import { useLayoutEffect } from "react";
import { useMatches } from "react-router-dom";
// The server-rendered <title> (the company name), captured before any route replaces it.
const baseTitle = document.title;
/**
 * Formats a page name as "Page | Company", falling back to the company name alone.
 * @param pageTitle The route's own name, if it declares one.
 * @returns The full document title.
 */
export const formatDocumentTitle = (pageTitle) => pageTitle && baseTitle ? `${pageTitle} | ${baseTitle}` : pageTitle || baseTitle;
/**
 * Sets document.title from the deepest matched route's `handle.title`.
 *
 * GA4 reads document.title as page_title on every page_view, including enhanced measurement's
 * history-change hits, so this is what names pages in GA4 reports. A layout effect runs before
 * the browser paints, which gets the title in place ahead of GA4 reading it after navigation.
 */
export const useDocumentTitle = () => {
    const matches = useMatches();
    const pageTitle = [...matches]
        .reverse()
        .map((match) => { var _a; return (_a = match.handle) === null || _a === void 0 ? void 0 : _a.title; })
        .find(Boolean);
    useLayoutEffect(() => {
        document.title = formatDocumentTitle(pageTitle);
    }, [pageTitle]);
};
